import updateDatalayer from "./gtm";
import {registerHtmlHook} from "../utils/htmlHooks";

const addToShoppingList = $('[role="addToShoppingList"]');
const shoppingListModal = $('#addToListModal');
const radio1 = addToShoppingList.find('#list1');
const radio2 = addToShoppingList.find('#list2');
const radio = addToShoppingList.find('[name=list]');
const formSelectGroup = addToShoppingList.find('.form-select-group-1');
const saveBtn = addToShoppingList.find('.saveBtn');
const listName = addToShoppingList.find('#listName');

const listContent1 = addToShoppingList.find('.modal-list-content-1');
const listContent2 = addToShoppingList.find('.modal-list-content-2');
const listContent3 = addToShoppingList.find('.modal-list-content-3');
const footer1 = addToShoppingList.find('.footer-1');
const footer2 = addToShoppingList.find('.footer-2');
const selectList1 = listContent1.find('select');

function resetModal() {
    listContent1.show();
    listContent2.hide();
    listContent3.hide();
    formSelectGroup.show();
    footer1.show();
    footer2.hide();
    radio.find('#list1').prop('checked', true);
    radio.find('#list2').prop('checked', false);
}

radio.change(function() {
    if (this.value === 'list') {
        listContent1.show();
        listContent2.hide();
    }
    else if (this.value === 'new-list') {
        listContent2.show();
        listContent1.hide();
    }
});

saveBtn.on('click', function () {
    // save action
    let productId = $(this).data('product-id');
    let quantity = $(this).data('quantity');
    let mode = $('#addToListModal input[name="list"]:checked').val();
    let newList = listName.val() ? listName.val() : null;
    let selected = selectList1 ? selectList1.val() : null;

    window.axios.post(window.config.urls.favorites.add, {
        product_id: productId,
        quantity: quantity || 1,
        mode: mode,
        new: newList,
        selected: selected,
    }).then(({data}) => {
        if (data.success) {
            this.success = true;

            shoppingListModal.find('#addedToListModalContent').html(data.content);

            listContent1.hide();
            listContent2.hide();
            listContent3.show();
            formSelectGroup.hide();
            footer1.hide();

            footer2.find('.go-to-specific-shopping-list').attr('href', data.url).removeClass('d-none');
            footer2.show();

            $("#addToExistingList").removeClass('d-none');

            updateDatalayer(
                'add_to_wishlist',
                data.cartItem.attributes.snapshot.material_number,
                data.cartItem.name,
                1,
                data.cartItem.price,
                null
            );
        }
    });
});

const myModalEl = document.getElementById('addToListModal');
if (myModalEl !== null) {
    myModalEl.addEventListener('hidden.bs.modal', function (event) {
        resetModal();
    })
}

const addToListBtn = document.querySelectorAll('.add-to-list');

const registerListener = function (elements) {
    Array.from(elements).forEach((element, index) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            let productId = $(event.target).closest('a').data('product-id');
            saveBtn.data('product-id', productId);

            let quantity = $('.quantity[data-product-id="'+productId+'"] input').val();
            saveBtn.data('quantity', quantity || 1);

            window.axios.get(window.config.urls.favorites.list).then(({data}) => {
                let favorites = data.favorites;

                // update list
                if (favorites.length < 1) {
                    radio1.prop('checked', false);
                    radio1.disabled = true;
                    radio2.prop('checked', true);
                    listContent2.show();
                    listContent1.hide();
                } else {
                    radio1.prop('checked', true);
                    selectList1.html('');
                    $.each(favorites, function(key, element) {
                        if (key == 0) {
                            selectList1.append($('<option selected></option>').val(element.id).text(element.name));
                        } else {
                            selectList1.append($('<option></option>').val(element.id).text(element.name));
                        }
                    });
                }

                shoppingListModal.modal('show');
            })
        });
    });
}

if (addToListBtn.length > 0) {
    registerListener(addToListBtn);
}

registerHtmlHook((container) => registerListener(container.querySelectorAll('.add-to-list')));
